<template>
  <div class="navbar-button" @click="$emit('click')">
    <!-- Button content -->
    <slot></slot>
  </div>
</template>

<script>
// @group Navbar
// Navbar button
export default {
  name: "NavbarButton"
};
</script>

<style scoped>
.navbar-button {
  background-color: #ed5229;
  color: white;
  font-size: 13px;
  font-family: "Arial";

  border: none;
  border-radius: 0.25em;

  padding: 0 10px 0 10px;
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .navbar-button {
    cursor: pointer;
  }
}

/** Mobile */
@media only screen and (max-width: 991px) {
  .navbar-button {
    box-sizing: border-box;
    height: 40px;
    width: 100%;
  }
}
</style>
